import styled from "styled-components";

export const FlagContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const CarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  animation: bounching 2s 0.5s ease-in-out infinite;

  &::before {
    background: var(--secondary-glow);
    border-radius: 50%;
    width: 180px;
    height: 90px;
    margin-left: 50px;
  }
  &::after {
    background: var(--primary-glow);
    width: 180px;
    height: 90px;
    z-index: -1;
  }

  &::before,
  ::after {
    content: "";
    left: 50%;
    position: absolute;
    filter: blur(45px);
    transform: translateZ(0);
  }

  @keyframes bounching {
    0% {
      transform: translateY(-10px);
      background-position: 0% 100%;
    }
    50% {
      transform: translateY(0px);
      background-position: 100% 0%;
    }
    100% {
      transform: translateY(-10px);
      background-position: 0% 100%;
    }
  }
`;

export const Flag = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -30px;
  margin-right: -5px;
  height: 60px;
  background-color: #59e4b9;
  animation: wave 2s infinite linear;
  h2 {
    margin: 0;
    padding: 0;
    color: var(--red-light);
    margin: 0 1rem;
  }
  @keyframes wave {
    0%,
    100% {
      transform: skewY(0deg);
    }
    50% {
      transform: skewY(
        6deg
      ); /* Adjust the skew angle for a more realistic effect */
    }
  }
`;
